import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-inline-media]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-inline-media-play]').forEach((btn) => {
    btn.addEventListener('click', playVideo);
  });
}

/**
 * Function to play video, set its autoplay and toggle classes to control its visibility
 *
 * @param e
 */
function playVideo(e) {
  const button = e.target;

  const inlineMedia = button.closest('[data-au-inline-media]');
  const iframe = inlineMedia.querySelector('[data-au-inline-media-iframe]');
  const iframeSrc = iframe.getAttribute('src');
  const iframeSrcAutoplay = `${iframeSrc}&autoplay=1`;

  // add autoplay to iframe
  iframe.setAttribute('src', iframeSrcAutoplay);
  iframe.removeAttribute('tabindex');

  // add au-inline-media--video-visible class to show video
  inlineMedia.classList.add('au-inline-media--video-visible');
}

export default { init };
